<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">GitHub斩获3K星！腾讯优图推动多模态大语言模型的创新研究</div>
      <div class="news-date">2023年7月14日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          近日，
          <span class="mark-text highlight">腾讯优图实验室与中国科学技术大学携手，共同发表了一篇名为《A Survey on Multimodal Large Language Models》的学术论文。</span>
          该文对多模态大语言模型（MLLM）进行了全面总结，对于AI大模型的整体发展起到了重要推动作用，论文列表实时更新，目前已在GitHub斩获3K星。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news39.png"/>
          </div>
        </div>
        <div class="download-article-wrap">
          <div class="download-article">
            <span class="mark-text">项目链接：</span>
            <a href="https://github.com/BradyFU/Awesome-Multimodal-Large-Language-Models" target="_blank" title="Awesome-Multimodal-Large-Language-Models">https://github.com/BradyFU/Awesome-Multimodal-Large-Language-Models</a>
          </div>
        </div>
        <p>
          多模态大语言模型（MLLM）是一种创新的人工智能模型，利用强大的大语言模型作为核心，具备处理多模态任务的能力。相较于传统模型，MLLM能够处理多模态信息，如写故事和OCR-free数学推理，更加贴合人类感知世界的方式。传统大语言模型在理解离散文本方面表现出色，但在视觉信息处理方面存在一定的局限性，而MLLM则填补了这一空白。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news39/news39_1.png"/>
          </div>
        </div>

        <p>
          该文章中，研究团队详细介绍了MLLM的概念、关键技术和应用。文章将MLLM分为四个主要类型：
          <span class="mark-text">多模态指令调优（M-IT）、多模态上下文学习（M-ICL）、多模态思维链（M-CoT）和LLM辅助视觉推理（LAVR）。</span>
          这些类型展示了MLLM在不同领域中的强大能力。
        </p>
        <p>在多模态指令调优（M-IT）方面，研究者通过在指令格式数据集上对预训练的LLM进行调优，使其能够根据新的指令推广到未见过的任务。这意味着通过针对具体任务的指令进行微调，MLLM可以适应并执行不同的视觉推理任务。这种方法有效地提高了MLLM的适应性和泛化能力，使其能够在未见过的情景下进行推理和解决问题。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news39/news39_2.png"/>
            <span>M-ICL样例</span>
          </div>
        </div>
        <p>
          <span class="mark-text">多模态上下文学习（M-ICL）和多模态思维链（M-CoT）则是对传统的上下文学习和推理链进行了扩展，使MLLM能够处理更加复杂的推理任务。</span>
          通过融合多模态信息和利用推理链的能力，MLLM可以从多个视觉和语言输入中提取上下文信息，并在推理过程中逐步推进，从而解决具有挑战性的推理问题。这种扩展使得MLLM能够更全面地理解和处理多模态任务，具备更强大的推理和解决问题的能力。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news39/news39_3.png"/>
            <span>M-CoT总结</span>
          </div>
        </div>
        <p>另外，LLM辅助视觉推理（LAVR）是一种以LLM为核心的多模态系统，专门用于辅助视觉推理任务。在这种系统中，LLM作为控制器和决策者，负责将复杂的视觉推理任务分解为简单的子任务，并将其分配给适当的工具或模块。LLM利用其丰富的语言学和语义知识，输出任务计划或调用相应的模块进行处理。这种系统充分发挥了LLM的可解释性、交互性和控制能力，使用户能够在用户友好的界面上进行精细控制，无需昂贵的策划数据集，从而实现更高效、准确的视觉推理。</p>
        <p>文章进一步探讨了MLLM的学习范式和模态桥接技术，这些方面对于提高MLLM在多模态任务中的表现和性能至关重要。</p>
        <p>
          在学习范式方面，研究者提出了几种方法来增强MLLM的学习能力，包括微调、少样本学习和零样本学习等。微调是通过在特定任务或领域的数据上对预训练的LLM进行进一步训练，以使其适应新任务的特定要求。少样本学习旨在让MLLM在面对少量样本的情况下仍然能够快速适应和学习。而零样本学习则是使MLLM具备在未见过的任务或领域中进行推理和学习的能力。
          <span class="mark-text">这些学习范式的引入使得MLLM具备了更广泛的适应性和泛化能力，能够在面对不同的任务和数据情境时展现出强大的性能。</span>
        </p>
        <p>
          另一方面，模态桥接技术是将多模态信息与自然语言处理相结合的关键技术，用于实现不同模态之间的交互和融合。在多模态任务中，模态桥接技术可以通过将不同模态的特征进行融合，使得模型能够更好地理解和处理多模态数据。例如，通过将视觉输入转化为文本描述，可以使得视觉信息能够与自然语言处理模型进行交互和融合，从而实现更好的推理和理解能力。
          <span class="mark-text">模态桥接技术的引入有助于提高MLLM在多模态任务中的表现，使其能够更好地处理和利用多模态信息，从而提升整体性能。</span>
        </p>
        <p>文章还介绍了评估MLLM性能的方法，包括封闭集和开放集的评估指标。封闭集评估主要在基准数据集上进行，而开放集评估则需要模型具备聊天机器人的能力。研究者还提出了一些新的基准测试，以全面评估MLLM的性能。</p>
        <p>尽管MLLM在视觉推理领域取得了显著进展，但仍面临一些挑战和改进空间。其中包括提升MLLM的感知能力，改善推理链的健壮性和指令跟随能力，解决幻觉问题等。未来的研究方向将聚焦于开发高效的参数训练方式和提升MLLM的可靠性与性能。</p>
        <p>
          <span class="mark-text highlight">腾讯优图实验室和中国科学技术大学的合作为MLLM辅助视觉推理领域带来了重要突破，为人工智能技术的发展开辟了新的前景。</span>
          该文章为未来视觉推理系统的构建和改进提供了建设性建议，有望推动AI大模型领域的进一步发展。
        </p>
        <br>
        <div class="download-article-wrap">
          <div class="download-article">
            <span class="mark-text">原文地址：</span>
            <a href="https://arxiv.org/pdf/2306.13549.pdf" target="_blank" title="A Survey on Multimodal Large Language Models">https://arxiv.org/pdf/2306.13549.pdf</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News33',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News39.vue